
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

export function GenderSelection({ onSelect }) {
  return (
    <motion.div
      className="max-w-2xl mx-auto text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-bold text-[#ff3366] mb-8">
        Selecione o Sexo Biológico
      </h2>
      
      <div className="grid gap-6 md:grid-cols-2">
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-xl font-semibold text-[#ff3366] mb-4">
            Masculino
          </h3>
          <p className="text-white/80 mb-6">
            Análise específica para homens, incluindo avaliação de hipogonadismo
          </p>
          <Button
            onClick={() => onSelect("Masculino")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            Selecionar
          </Button>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-xl font-semibold text-[#ff3366] mb-4">
            Feminino
          </h3>
          <p className="text-white/80 mb-6">
            Análise específica para mulheres, incluindo avaliação de climatério
          </p>
          <Button
            onClick={() => onSelect("Feminino")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            Selecionar
          </Button>
        </motion.div>
      </div>
    </motion.div>
  );
}
